<template>
  <validation-provider
    v-slot="{ errors }"
    :name="$attrs.name"
    :rules="iRules"
    :vid="vid"
  >
    <v-label
      v-if="fixedLabel"
      :dark="fixedLabelDark"
    >
      {{ displayLabel }}
    </v-label>
    <v-text-field
      ref="input"
      v-model="iValue"
      v-bind="$attrs"
      :background-color="backgroundColor"
      :clear-icon="'far fa-times-circle'"
      :counter="counter"
      :dense="dense"
      :error-messages="errors"
      :error="validation && errors.length > 0"
      :hide-details="(!validation || errors.length === 0) && !counter"
      :label="(!fixedLabel && displayLabel) || ''"
      :outlined="outlined"
      :prefix="$t(prefix)"
      v-on="$listeners"
    />
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { useValidation } from '@/compositions/validation'

export default {
  name: 'FieldString',
  components: {
    ValidationProvider
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'white'
    },
    counter: {
      type: [Boolean, Number, String],
      default: null
    },
    dense: {
      type: Boolean,
      default: true
    },
    fixedLabel: Boolean,
    fixedLabelDark: Boolean,
    label: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: true
    },
    prefix: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Object],
      default: () => ({})
    },
    validation: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: () => undefined
    },
    vid: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const { iRules, displayLabel } = useValidation(props)

    return { iRules, displayLabel }
  },
  computed: {
    iValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    }
  }
}
</script>
